import type { SampleListMode } from '@/lib/sampleList/sampleListMode';
import { useSampleFilterStore } from '@/stores/sampleFilterStore';
import { useSubstrateFilterStore } from '@/stores/substrateFilterStore';

/** Same shape as sample/substrate filter stores; pick by page mode. */
export type SampleListFilterStore = {
  filters: ReturnType<typeof useSampleFilterStore.getState>['filters'];
  sampleGridApplyGeneration: number;
  isSearching: boolean;
  growthDateSetFromBasicRow?: boolean;
  addedBySetFromBasicRow: boolean;
  setIsSearching: (isSearching: boolean) => void;
  setFilters: ReturnType<typeof useSampleFilterStore.getState>['setFilters'];
  resetFilters: () => void;
  paginationModel: { page: number; pageSize: number };
  setPaginationModel: ReturnType<typeof useSampleFilterStore.getState>['setPaginationModel'];
  ensureFreshSampleGridServerRequest: () => void;
};

/**
 * Returns the filter store for the Samples page or the Substrates page.
 * Both hooks run (Rules of Hooks); only the selected store is returned.
 */
export function useSampleListFilterStore(mode: SampleListMode = 'samples'): SampleListFilterStore {
  const sample = useSampleFilterStore();
  const substrate = useSubstrateFilterStore();
  if (mode === 'substrates') {
    return substrate;
  }
  return sample;
}

export function getSampleListFilterStoreState(mode: SampleListMode) {
  return mode === 'substrates' ? useSubstrateFilterStore.getState() : useSampleFilterStore.getState();
}
